export default () => jQuery(($) => {

	const dates = $('#calendar .eventDetails .dates');
	dates.hide();

	const explanation = $('#calendar .eventDetails .explanation');

	if (explanation.length > 0) {
		const showText = 'Show all dates';
		const hideText = 'Hide all dates';
		const toggler = $('<span class="datesToggler show"> <a href="#">' + showText + '</a></span>');
		toggler.find('a').click(function (e) {
			if (dates.is(':hidden')) {
				dates.show(400);
				toggler.find('.datesToggler').removeClass('show').addClass('hide');
				$(this).empty().append(hideText);
				e.preventDefault();
			}
			else {
				dates.hide(400);
				toggler.find('.datesToggler').removeClass('hide').addClass('show');
				$(this).empty().append(showText);
				e.preventDefault();
			}
		});
		toggler.appendTo(explanation);
	}

	const regList = $('#slotInfo>ul>li');
	if (regList.length > 8) {
		const count = 0;
		const shower = $('<li class="shower"><a href="#"><strong>Show more dates</strong></a></li>');
		shower.find('a').click(function (e) {
			regList.show();
			shower.hide();
			e.preventDefault();
		});
		regList.each(function () {
			count++;
			if (count > 7) {
				if (8 === count)
					$(this).before(shower);
				$(this).hide();
			}
		});
	}
 
});
